<template>
<div class="collabsable-section">
    <div class="section-title clickable-header" @click="toggleExpanded()">
        <div class="model-3d"></div>
        <div style="flex-grow: 1;font-size: 17px;">Models</div>
        <div style="color: gray;" :class="['expand-collapse-ico','fas',!isExpanded?'fa-caret-down':'fa-caret-up']"></div>
    </div>
    <div v-if="isExpanded" class="expanded-section">
        <div v-for="item in models" :key="item.id" class="model-row" @click="clickOnMasterModel(item)">
            <input type="radio" class="model-version-checkbox" :value="item.name" v-model="selectedModelName" @change="mainVersionCheckboxChecked()" @click.stop="" />
            <b style="padding-left: 5px;flex-grow:1;">{{item.name}} ({{item.version}})</b><br />
            <div class="btn-hover-orange fas fa-trash" @click.stop="onItemDeleting(item)"></div>
        </div>
        <div class="info-section" style="align-items: center;flex-direction: row;">
            <div class="admin-btn" style="margin-right: 7px;" @click="showUploadForm()">Upload</div>
            <div v-if="canAddEmptyModel" class="secondary-btn" style="margin-right: 7px;width: fit-content;" @click="addEmptyModel()">Add Empty Model</div>
        </div>
    </div>
</div>
</template>

<script>
import { checkIsModelTrasnlated } from '@/utils/forgeUtils'
import { toggleExpandComponent } from '@/scripts/js/forgeviewer'
import HttpService from '@/utils/httpService'

export default {
    name: 'AdminModels',
    data() {
        return {
            isExpanded: false,
            selectedModelName: '',
        }
    },
    watch: {
        models: function () {
            this.selectedModelName = this.models.find(o => o.isMainVersion) ? this.models.find(o => o.isMainVersion).name : '';
        }
    },
    methods: {
        showUploadForm() {
            document.getElementById("uploadModelsModal").style.display = "flex";
        },
        addEmptyModel() {
            HttpService.post({
                url: `api/assets/addEmptyModel`,
                data: {
                    assetId: this.$store.state.assetId,
                    userUpdated: this.$store.state.username,
                }
            }).then(response => {
                let model = response.data;
                this.$store.state.uploadedModels.forEach(o => o.isMainVersion = false);
                model.isMainVersion = true;
                this.$store.state.uploadedModels.push(model);
                this.$store.dispatch({type: 'showSuccessfulMessage',message: "Empty model created successfully.", timeout: 2000})
            }).catch(console.error);
        },
        mainVersionCheckboxChecked() {
            this.models.forEach(o => {
                if (o.name != this.selectedModelName)
                    o.isMainVersion = false;
                else {
                    o.isMainVersion = true;
                    this.forgeService.saveMasterModel(this.$store.state.assetId, o.name);
                }
            });
        },
        clickOnMasterModel(model) {
            if (!model) return;
            var _this = this;
            checkIsModelTrasnlated(model.urn, (isTranslated, progress) => {
                if (!isTranslated) {
                    this.$store.dispatch({
                        type: "alert_Forge",
                        message: 'Model translation in progress.' + progress
                    })
                    return;
                } else {
                    _this.$emit('launch-viewer', model);
                }
            })
        },
        onItemDeleting(model) {
            this.$store.dispatch({
                type: "confirm_Forge",
                message: 'Are you sure you want to delete model?',
                callback: () => {
                    if (this.getSelectedModel() == model) {
                        this.$emit('dispose3DViewer');
                    }
                    this.forgeService.deleteVersion(this.$store.state.assetId, model.urn, () => {
                        let index = this.models.findIndex(o => o == model);
                        this.models.splice(index, 1);
                        this.$store.dispatch({ type: 'showSuccessfulMessage', message: "Model deleted successfully.", timeout: 2000 })
                    });
                }
            })
        },
        getSelectedModel() {
            return this.models.find(o => o.isMainVersion);
        },
        toggleExpanded() {
            toggleExpandComponent(this);
        }

    },
    computed:{
        forgeService() {
            return this.$store.state.forgeService;
        },
        models(){
            return this.$store.state.uploadedModels
        },
        canAddEmptyModel () {
            return this.models.every(m => m.name != 'Empty Model')
        }
    },
}
</script>

<style>
.model-3d {
    background-size: cover;
    background-image: url(../../../images/3d-black.png);
    width: 23px;
    height: 23px;
    margin-right: 10px;
}
</style>
